var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13461_165956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2535 23.02C11.0265 23.7022 12.0418 24.1162 13.1539 24.1162C14.2659 24.1162 15.2812 23.7022 16.0542 23.02M19.731 8.76953C19.731 7.02516 19.0381 5.35224 17.8046 4.11878C16.5712 2.88533 14.8982 2.19238 13.1539 2.19238C11.4095 2.19238 9.73658 2.88533 8.50313 4.11878C7.26967 5.35224 6.57672 7.02516 6.57672 8.76953C6.57672 12.157 5.72221 14.4763 4.76764 16.0103C3.96245 17.3043 3.55985 17.9513 3.57461 18.1318C3.59096 18.3317 3.6333 18.4079 3.79434 18.5274C3.93979 18.6353 4.59546 18.6353 5.90679 18.6353H20.401C21.7123 18.6353 22.368 18.6353 22.5134 18.5274C22.6745 18.4079 22.7168 18.3317 22.7331 18.1318C22.7479 17.9513 22.3453 17.3043 21.5401 16.0103C20.5855 14.4763 19.731 12.157 19.731 8.76953Z",
    stroke: "white",
    strokeWidth: 2.19238,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.34,
    cy: 4.78338,
    r: 4.78338,
    fill: "#FF0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13461_165956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.3086,
    height: 26.3086,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell01);
export default __webpack_public_path__ + "static/media/bell-01.c2b906e1495e9ac9aefa32191bccfa0e.svg";
export { ForwardRef as ReactComponent };